// What a refused key write says (`apps/server/src/http/anthropic-key.ts`
// answers closed codes only, never the key): the key check's codes, plus the
// codes the admin page's assign and remove meet (`admin/useAnthropicKeysAdmin.ts`).

import type { MessageKey } from "../i18n/index.js";
import { failureCodeOf } from "../lib/http";

type CodeCopy = ReadonlyArray<readonly [code: string, line: MessageKey]>;

const KEY_CHECK_COPY: CodeCopy = [
  ["key_malformed", "account.anthropic.error.malformed"],
  ["key_rejected", "account.anthropic.error.rejected"],
  ["key_check_failed", "account.anthropic.error.checkFailed"],
];

/** The line for a failed write: its code's own line, else `fallback`. */
export const keyFailureCopy = (
  own: CodeCopy,
): ((err: unknown, fallback: MessageKey) => MessageKey) => {
  const copy = new Map([...KEY_CHECK_COPY, ...own]);
  return (err, fallback) => {
    const { code } = failureCodeOf(err);
    return (code !== null ? copy.get(code) : undefined) ?? fallback;
  };
};
